var _regeneratorRuntime = require("/home/ben/workspace/showhow.v2/src/main/app/node_modules/react-scripts-ts/node_modules/@babel/runtime/regenerator");

var _defineProperty = require("/home/ben/workspace/showhow.v2/src/main/app/node_modules/react-scripts-ts/node_modules/@babel/runtime/helpers/defineProperty");

var _asyncToGenerator = require("/home/ben/workspace/showhow.v2/src/main/app/node_modules/react-scripts-ts/node_modules/@babel/runtime/helpers/asyncToGenerator");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var breathe = require('./utils/breathe'); //Parse GPSU date format


function toDate(d) {
  var regex = /(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})\.(\d{3})/;
  var YEAR = 1,
      MONTH = 2,
      DAY = 3,
      HOUR = 4,
      MIN = 5,
      SEC = 6,
      MIL = 7;
  var parts = d.match(regex);
  if (parts) return new Date(Date.UTC('20' + parts[YEAR], parts[MONTH] - 1, parts[DAY], parts[HOUR], parts[MIN], parts[SEC], parts[MIL])).getTime();
  return null;
} //Create list of GPS dates, times and duration for each packet of samples


function fillGPSTime(_x, _x2, _x3) {
  return _fillGPSTime.apply(this, arguments);
} //Create date, time, duration list based on mp4 date and timing data


function _fillGPSTime() {
  _fillGPSTime = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(klv, options, timeMeta) {
    var gpsDate, res, missingDates, missingDurations, lastMissing, avgDuration, nextGood;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            gpsDate = timeMeta.gpsDate;
            res = []; //Ignore if timeIn selects the other time input

            if (!(options.timeIn === 'MP4' || options.mp4header)) {
              _context.next = 4;
              break;
            }

            return _context.abrupt("return", res);

          case 4:
            missingDates = [];
            klv.DEVC.forEach(function (d, i) {
              //Object with partial result
              var partialRes;
              var date; //Loop strams if present

              if (d != null && d.STRM && d.STRM.length) {
                for (var key in d.STRM) {
                  //Find the GPSU date in the GPS5 stream
                  if (d.STRM[key].GPSU != null) {
                    date = toDate(d.STRM[key].GPSU); //Done with GPSU

                    if (options.stream && !options.stream.includes('GPS5') || d.STRM[key].toDelete) {
                      delete d.STRM[key];
                    } else delete d.STRM[key].GPSU;

                    break;
                  }
                }
              }

              if (date != null) {
                if (gpsDate == null) {
                  gpsDate = date; // Save initial date for future use

                  timeMeta.gpsDate = gpsDate;
                }

                partialRes = {
                  date: date
                }; // Assign duration for previous pack. The last one will lack it

                if (res.length && res[res.length - 1] && res[res.length - 1].date) {
                  res[res.length - 1].duration = partialRes.date - res[res.length - 1].date;
                }
              }

              if (partialRes) {
                //Deduce starting time from date and push result
                partialRes.cts = partialRes.date - gpsDate;
                res.push(partialRes);
              } else {
                res.push(null);
                missingDates.push(i);
              }
            });
            missingDurations = []; //Deduce null results as accurately as possible

            missingDates.forEach(function (i) {
              //If a previous date is present
              if (res[i] === null && res[i - 1] && res[i - 1].date) {
                var foundNext = false;

                for (var x = 1; i + x < res.length; x++) {
                  // Look for the next valild date
                  if (res[i + x] && res[i + x].date) {
                    //And interpolate to find the previous one
                    res[i - 1].duration = (res[i + x].date - res[i - 1].date) / x; //Duration set, remove from missingDurations

                    var index = missingDurations.indexOf(i - 1);
                    if (index !== -1) missingDurations.splice(index, 1);
                    foundNext = true;
                    break;
                  }
                }

                if (!foundNext) {
                  //If no date but previous packets have one, deduce from them. 1Hz as fallback
                  var lastDuration = 1000;

                  for (var j = i - 2; j >= 0; j--) {
                    if (res[j] && res[j].duration) {
                      lastDuration = res[j].duration;
                      break;
                    }
                  }

                  res[i - 1].duration = lastDuration;
                }

                if (res[i - 1].duration != null) {
                  // Deduce date and starting time form previous date and duration
                  res[i] = {
                    date: res[i - 1].date + res[i - 1].duration
                  };
                  res[i].cts = res[i].date - gpsDate;
                  missingDurations.push(i);
                }
              }
            }); // Fill initial, non fixed dates

            lastMissing = -1;

            while (res[lastMissing + 1] == null && lastMissing < res.length) {
              lastMissing++;
            }

            if (lastMissing >= 0 && res.length > lastMissing + 2) {
              avgDuration = (res.slice(-1)[0].date - res[lastMissing + 1].date) / (res.length - (lastMissing + 1));

              while (lastMissing >= 0) {
                nextGood = res[lastMissing + 1];
                res[lastMissing] = {
                  date: nextGood.date - avgDuration,
                  cts: nextGood.cts - avgDuration,
                  duration: avgDuration
                };
                lastMissing--;
              }
            } // Fix negative CTS


            if (res[0] && res[0].cts < 0) res = res.map(function (r) {
              return _objectSpread(_objectSpread({}, r), {}, {
                cts: r.cts - res[0].cts
              });
            }); //Fill missing durations

            missingDurations.forEach(function (i) {
              if (res[i + 1] && res[i + 1].date) res[i].duration = res[i + 1].date - res[i].date;
            }); //If only one group of samples, invent duration to get at least some useful results

            if (res.length === 1 && res[0] != null && res[0].duration == null) res[0].duration = 1001;
            return _context.abrupt("return", res);

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _fillGPSTime.apply(this, arguments);
}

function fillMP4Time(_x4, _x5, _x6, _x7) {
  return _fillMP4Time.apply(this, arguments);
} //Assign time data to each sample


function _fillMP4Time() {
  _fillMP4Time = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(klv, timing, options, timeMeta) {
    var offset, mp4Date, res;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            offset = timeMeta.offset, mp4Date = timeMeta.mp4Date;
            if (!offset) offset = 0;
            res = []; //Ignore if timeIn selects the other time input

            if (!(options.timeIn === 'GPS' || options.mp4header)) {
              _context2.next = 5;
              break;
            }

            return _context2.abrupt("return", res);

          case 5:
            //Invent timing data if missing
            if (!timing || !timing.samples || !timing.samples.length) {
              timing = {
                frameDuration: 0.03336666666666667,
                start: new Date(),
                samples: [{
                  cts: 0,
                  duration: 1001
                }]
              };
            } //Set the initial date, the only one provided by mp4


            if (typeof timing.start != 'object') timing.start = new Date(timing.start);

            if (!mp4Date) {
              mp4Date = timing.start.getTime();
              timeMeta.mp4Date = mp4Date;
            }

            klv.DEVC.forEach(function (d, i) {
              //Will contain the timing data about the packet
              var partialRes = {}; //Copy cts and duration from mp4 if present

              if (timing.samples[i] != null) {
                partialRes = JSON.parse(JSON.stringify(timing.samples[i])); // Add offset if merging clips

                if (offset) partialRes.cts += offset;
              } else {
                //Deduce it from previous sample
                partialRes.cts = res[i - 1].cts + (res[i - 1].duration || 0); //Don't assume previous duration if last pack of samples. Could be shorter

                if (i + 1 < klv.DEVC.length) {
                  if (res[i - 1].duration) partialRes.duration = res[i - 1].duration;else if (i > 1 && res[i - 2].duration) {
                    partialRes.duration = res[i - 2].duration;
                  }
                }
              } //Deduce the date by adding the starting time to the initial date, and push


              partialRes.date = mp4Date + partialRes.cts;
              res.push(partialRes); //Delete GPSU

              if (d != null && d.STRM && d.STRM.length) {
                for (var key in d.STRM) {
                  //Find the GPSU date in the GPS5 stream
                  if (d.STRM[key].GPSU != null) {
                    //Done with GPSU
                    if (options.stream && !options.stream.includes('GPS5') || d.STRM[key].toDelete) {
                      delete d.STRM[key];
                    } else delete d.STRM[key].GPSU;

                    break;
                  }
                }
              }
            });
            return _context2.abrupt("return", res);

          case 10:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _fillMP4Time.apply(this, arguments);
}

function timeKLV(_x8, _x9, _x10) {
  return _timeKLV.apply(this, arguments);
}

function _timeKLV() {
  _timeKLV = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(klv, timing, options) {
    var timeMeta,
        offset,
        result,
        _args5 = arguments;
    return _regeneratorRuntime.wrap(function _callee4$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            timeMeta = _args5.length > 3 && _args5[3] !== undefined ? _args5[3] : {};
            offset = timeMeta.offset;
            if (!offset) offset = 0; //Copy the klv data

            try {
              result = JSON.parse(JSON.stringify(klv));
            } catch (error) {
              result = klv;
            }

            _context5.prev = 4;

            if (!(result.DEVC && result.DEVC.length)) {
              _context5.next = 9;
              break;
            }

            return _context5.delegateYield( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
              var gpsTimes, mp4Times, sDuration, dateSDur, _loop, i;

              return _regeneratorRuntime.wrap(function _callee3$(_context4) {
                while (1) {
                  switch (_context4.prev = _context4.next) {
                    case 0:
                      _context4.next = 2;
                      return fillGPSTime(result, options, timeMeta);

                    case 2:
                      gpsTimes = _context4.sent;
                      _context4.next = 5;
                      return fillMP4Time(result, timing, options, timeMeta);

                    case 5:
                      mp4Times = _context4.sent;
                      //Will remember the duration of samples per (fourCC) type of stream, in case the last durations are missing
                      sDuration = {};
                      dateSDur = {}; //Loop through packets of samples

                      _loop = /*#__PURE__*/_regeneratorRuntime.mark(function _loop(i) {
                        var d, _ref, cts, duration, _ref2, date, dateDur, dInitialDate, dummyStream, skipSTMP;

                        return _regeneratorRuntime.wrap(function _loop$(_context3) {
                          while (1) {
                            switch (_context3.prev = _context3.next) {
                              case 0:
                                _context3.next = 2;
                                return breathe();

                              case 2:
                                d = result.DEVC[i]; //Choose timing type for time (relative to the video start) data.

                                _ref = function () {
                                  if (mp4Times.length && mp4Times[i] != null) return mp4Times[i];else if (gpsTimes.length && gpsTimes[i] != null) return gpsTimes[i];
                                  return {
                                    cts: null,
                                    duration: null
                                  };
                                }(), cts = _ref.cts, duration = _ref.duration; //Choose timing type for dates (ideally based on GPS).

                                _ref2 = function () {
                                  if (gpsTimes.length && gpsTimes[i] != null) return gpsTimes[i];else if (mp4Times.length && mp4Times[i] != null) return mp4Times[i];
                                  return {
                                    date: null,
                                    duration: null
                                  };
                                }(), date = _ref2.date, dateDur = _ref2.duration; //Choose initial date in case it's necessary

                                dInitialDate = function () {
                                  if (gpsTimes.length && timeMeta.gpsDate) return timeMeta.gpsDate;
                                  if (mp4Times.length && timeMeta.mp4Date) return timeMeta.mp4Date;
                                  return 0;
                                }(); //Create empty stream if needed for timing purposes


                                dummyStream = {
                                  STNM: 'UTC date/time',
                                  interpretSamples: 'dateStream',
                                  dateStream: ['0']
                                };
                                if (d.STRM && options.dateStream) d.STRM.push(dummyStream); // Only use STMP when clearly one file or consecutive files

                                skipSTMP = false; //Loop streams if present

                                (d.STRM || []).forEach(function (s, ii) {
                                  //If group of samples found
                                  if (s.interpretSamples && s[s.interpretSamples] && s[s.interpretSamples].length) {
                                    var fourCC = s.interpretSamples;

                                    if (!options.mp4header) {
                                      //Will store the current Cts
                                      var currCts;
                                      var currDate;

                                      if (ii === 0) {
                                        // Evaluate convenience of STMP on first sample
                                        // Only use timestamps if not removing gap
                                        if (options.removeGaps) skipSTMP = true; // If no mp4Times, don't bother
                                        else if (!mp4Times.length) skipSTMP = true; // Arbitrarily, anything outside 2 seconds from the current offset should not use STMP either
                                        else if (s.STMP / 1000 > mp4Times[i].cts + 1000 * 2) {
                                          skipSTMP = true;
                                        } // (It's either a non-initial isolated file or a file not directly consecutive in the series)
                                        else if (s.STMP / 1000 < mp4Times[i].cts - 1000 * 2) {
                                          skipSTMP = true;
                                        }
                                      } //Use sDuration and cts from microsecond timestamps if available


                                      var microCts = false;
                                      var microDuration = false;
                                      var microDate = false;
                                      var microDateDuration = false;

                                      if (s.STMP != null) {
                                        if (!skipSTMP) {
                                          currCts = s.STMP / 1000;

                                          if (options.timeIn === 'MP4') {
                                            //Use timeStamps for date if MP4 timing is selected
                                            currDate = dInitialDate + currCts;
                                            microDate = true;
                                          }

                                          microCts = true; //Look for next sample of same fourCC

                                          if (result.DEVC[i + 1]) {
                                            //If next DEVC entry
                                            (result.DEVC[i + 1].STRM || []).forEach(function (ss) {
                                              //Look in each stream
                                              if (ss.interpretSamples === fourCC) {
                                                //Found matchin sample
                                                if (ss.STMP) {
                                                  //Has timestamp? Measure duration of all samples and divide by number of samples
                                                  sDuration[fourCC] = (ss.STMP / 1000 - currCts) / s[fourCC].length;
                                                  microDuration = true;

                                                  if (options.timeIn === 'MP4') {
                                                    //Use timeStamps for date if MP4 timing is selected
                                                    dateSDur[fourCC] = sDuration[fourCC];
                                                    microDateDuration = true;
                                                  }
                                                }
                                              }
                                            });
                                          }
                                        }

                                        delete s.STMP;
                                      } //Divide duration of packet by samples in packet to get sample duration per fourCC type


                                      if (!microDuration && duration != null) {
                                        sDuration[fourCC] = duration / s[fourCC].length;
                                      }

                                      if (!microCts) currCts = cts; //The same for duration of dates

                                      if (!microDateDuration && dateDur != null) {
                                        dateSDur[fourCC] = dateDur / s[fourCC].length;
                                      } //We know the time and date of the first sample


                                      if (!microDate) currDate = date; //Try to compensate delayed samples proportionally

                                      var timoDur = 0;

                                      if (s.TIMO) {
                                        //Substract time offset, but don't go under 0
                                        if (s.TIMO * 1000 > currCts) s.TIMO = currCts / 100;
                                        currCts -= s.TIMO * 1000;
                                        if (currCts < 0) currCts = 0;

                                        if (d.STRM[ii + 1] && d.STRM[ii + 1].TIMO) {
                                          //Find difference to next TIMO
                                          var timoDiff = d.STRM[ii + 1].TIMO - s.TIMO; //And calculate how much we must compensate each sample (interpolate)

                                          timoDur = 100 * timoDiff / s[fourCC].length;
                                        } //And compensate date


                                        currDate -= s.TIMO * 1000;
                                        delete s.TIMO;
                                      } //Loop samples and replace them with timed samples


                                      s[fourCC] = s[fourCC].map(function (value) {
                                        //If timing data avaiable
                                        if (currCts != null && sDuration[fourCC] != null) {
                                          var timedSample = {
                                            value: value
                                          }; //Filter out if timeOut option, but keep cts if needed for merging times

                                          if (options.timeOut !== 'date' || options.groupTimes) timedSample.cts = currCts;

                                          if (options.timeOut !== 'cts') {
                                            timedSample.date = new Date(currDate);
                                          } //increment time and date for the next sample and compensate time offset


                                          currCts += sDuration[fourCC] - timoDur;
                                          currDate += dateSDur[fourCC] - timoDur;
                                          return timedSample; //Otherwise return value without timing data
                                        } else return {
                                          value: value
                                        };
                                      });
                                    } else {
                                      //If no time required just store samples in value
                                      s[fourCC] = s[fourCC].map(function (value) {
                                        return {
                                          value: value
                                        };
                                      });
                                    }
                                  }
                                });

                              case 10:
                              case "end":
                                return _context3.stop();
                            }
                          }
                        }, _loop);
                      });
                      i = 0;

                    case 10:
                      if (!(i < result.DEVC.length)) {
                        _context4.next = 15;
                        break;
                      }

                      return _context4.delegateYield(_loop(i), "t0", 12);

                    case 12:
                      i++;
                      _context4.next = 10;
                      break;

                    case 15:
                    case "end":
                      return _context4.stop();
                  }
                }
              }, _callee3);
            })(), "t0", 7);

          case 7:
            _context5.next = 10;
            break;

          case 9:
            throw new Error('Invalid data, no DEVC');

          case 10:
            _context5.next = 19;
            break;

          case 12:
            _context5.prev = 12;
            _context5.t1 = _context5["catch"](4);

            if (!options.tolerant) {
              _context5.next = 18;
              break;
            }

            setImmediate(function () {
              return console.error(_context5.t1);
            });
            _context5.next = 19;
            break;

          case 18:
            throw _context5.t1;

          case 19:
            return _context5.abrupt("return", result);

          case 20:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee4, null, [[4, 12]]);
  }));
  return _timeKLV.apply(this, arguments);
}

module.exports = timeKLV;